import { Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCustomFuelSurchargeBuildTable extends Layout {
    textboxBaseCharge: Textbox;
    textboxEnd: Textbox;
    textboxFuelPriceIncrement: Textbox;
    textboxMethod: Textbox;
    textboxStart: Textbox;
    textboxSurchargeIncrememnt: Textbox;
}
